import { MotionPreferenceManager } from '../../utils/accessibilityUtils';
import type { AnimationType, TooltipPosition } from './types';

export const getAnimationClass = (animation: AnimationType, animationsEnabled: boolean): string => {
  if (!animationsEnabled) return '';

  // Check for reduced motion preference
  if (MotionPreferenceManager.prefersReducedMotion()) return '';

  switch (animation) {
    case 'pulse':
      return 'guide-pulse';
    case 'glow':
      return 'guide-glow';
    case 'bounce':
      return 'guide-bounce';
    case 'shake':
      return 'guide-shake';
    case 'none':
    default:
      return '';
  }
};

export const getTooltipArrowClass = (position: TooltipPosition): string => {
  switch (position) {
    case 'top':
      return 'tooltip-arrow-bottom';
    case 'bottom':
      return 'tooltip-arrow-top';
    case 'left':
      return 'tooltip-arrow-right';
    case 'right':
      return 'tooltip-arrow-left';
    default:
      return 'tooltip-arrow-top';
  }
};
